@if (stepModal) {
  <div
    ngClass="token-card-edit"
    [@inOutAnimationTokenEdit]="animationStateTokenEdit"
  >
    <div class="token-card-edit__header">
      <a class="token-card-edit__back" (click)="handleHideModalTokenEdit()">
        <img src="assets/svg-icons/left-arrow-vector.svg" alt="go back" />
        Back
      </a>
      <span>Saved cards</span>

      <button (click)="handleHideModalTokenEdit()">
        <img src="assets/svg-icons/close.svg" alt="close tag" />
      </button>
    </div>
    @if (paymentCards?.length) {
      <div class="token-card-edit__cards">
        <div class="token-card-edit__card" *ngFor="let card of paymentCards">
          <label
            class="token-card-edit__card-label"
            [ngClass]="{ checked: card.id === selectedPaymentCard?.id }"
          >
            <input
              type="radio"
              name="payment-card"
              [value]="card.id"
              (change)="handleChangePaymentMethod(card)"
              [checked]="card.id === selectedPaymentCard?.id"
              hidden
            />
            <ng-container *ngIf="card.id !== selectedPaymentCard?.id">
              <img
                src="assets/svg-icons/radio-default.svg"
                alt="radio unchecked"
              />
            </ng-container>
            <ng-container *ngIf="card.id === selectedPaymentCard?.id">
              <img
                src="assets/svg-icons/radio-filled.svg"
                alt="radio checked"
              />
            </ng-container>
            <div class="token-card-edit__card-header">
              <img
                [src]="
                  'assets/svg-icons/' +
                  card.card_type.toLowerCase() +
                  '-white.svg'
                "
                [alt]="card.card_type"
              />
              <span class="token-card-edit__card-header__title text-capitalize"
                >{{ card.card_type }} ••••
                {{ card.card_mask.slice(12, 16) }}</span
              >
              <span
                class="token-card-edit__card-header__default"
                *ngIf="card.id === paymentCards[0].id"
              >
                (default)
              </span>
            </div>
          </label>
        </div>
        <div class="token-card-edit__card">
          <label
            class="add-payment"
            [ngClass]="{ checked: selectedPaymentCard?.id === 'new' }"
          >
            <input
              type="radio"
              name="payment-card"
              [value]="'new'"
              (change)="handleChangePaymentMethod({ id: 'new' })"
              [checked]="selectedPaymentCard.id === 'new'"
              hidden
            />
            <ng-container *ngIf="selectedPaymentCard.id !== 'new'">
              <img
                src="assets/svg-icons/radio-default.svg"
                alt="radio unchecked"
              />
            </ng-container>
            <ng-container *ngIf="selectedPaymentCard.id === 'new'">
              <img
                src="assets/svg-icons/radio-filled.svg"
                alt="radio checked"
              />
            </ng-container>
            <div class="token-card-edit__card-content">
              <div class="token-card-edit__add-payment">
                <span class="token-card-edit__add-payment__title">
                  Add a new payment method
                </span>
                <div class="token-card-edit__add-payment__card-icon">
                  <span>We accept:</span>
                  <svg-icon name="visa"></svg-icon>
                  <svg-icon name="mastercard-new"></svg-icon>
                  <svg-icon name="google-pay"></svg-icon>
                  <svg-icon name="apple-pay-new"></svg-icon>
                </div>
              </div>
            </div>
          </label>
        </div>
      </div>
    }

    <div ngClass="token-card-edit__footer">
      <button
        *ngIf="selectedPaymentCard.id !== 'new'"
        (click)="handleHideModalTokenEdit()"
        [disabled]="disabled"
      >
        Confirm selection
      </button>
      <button
        *ngIf="selectedPaymentCard.id === 'new'"
        class="green"
        (click)="handleSubmit()"
        [disabled]="disabled"
      >
        Continue to payment
      </button>
    </div>
  </div>
}
